
import React from 'react';
import { TrendingUp, Users, Globe, Leaf } from 'lucide-react';
import { useLanguage } from '@/hooks/useLanguage';

export const StatisticsSection = () => {
  const { t } = useLanguage();
  const stats = [
    {
      icon: Users,
      number: '10M+',
      label: t('travelersLabel', 'statistics'),
      description: t('travelersDesc', 'statistics')
    },
    {
      icon: Globe,
      number: '500+',
      label: t('citiesLabel', 'statistics'),
      description: t('citiesDesc', 'statistics')
    },
    {
      icon: TrendingUp,
      number: '₹2.5B+',
      label: t('savedLabel', 'statistics'),
      description: t('savedDesc', 'statistics')
    },
    {
      icon: Leaf,
      number: '50K+',
      label: t('co2Label', 'statistics'),
      description: t('co2Desc', 'statistics')
    }
  ];

  const progressItems = [
    { label: t('costReductionLabel', 'statistics'), value: 70, suffix: t('costReductionSuffix', 'statistics') },
    { label: t('emissionReductionLabel', 'statistics'), value: 60, suffix: t('emissionReductionSuffix', 'statistics') },
    { label: t('userSatisfactionLabel', 'statistics'), value: 95, suffix: t('userSatisfactionSuffix', 'statistics') },
    { label: t('safetyRateLabel', 'statistics'), value: 99.8, suffix: t('safetyRateSuffix', 'statistics') }
  ];

  return (
    <section className="py-14 bg-white">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        {/* Section Header */}
        <div className="text-center mb-20">
          <h2 className="text-4xl md:text-6xl font-light text-gray-900 mb-6">
            {t('sectionTitle', 'statistics')}
          </h2>
          <p className="text-xl text-gray-600 max-w-2xl mx-auto font-light">
            {t('sectionSubtitle', 'statistics')}
          </p>
        </div>

        {/* Statistics Grid */}
        <div className="grid grid-cols-2 lg:grid-cols-4 gap-8">
          {stats.map((stat, index) => (
            <div 
              key={index}
              className="text-center group cursor-pointer"
            >
              <div className="bg-[#FFF8E9] rounded-3xl p-8 hover:shadow-lg transition-all duration-500 transform hover:-translate-y-1">
                <div className="w-16 h-16 mx-auto mb-6 rounded-2xl bg-white flex items-center justify-center group-hover:bg-[#22C55E] transition-all duration-300">
                  <stat.icon className="w-8 h-8 text-[#22C55E] group-hover:text-white transition-colors duration-300" />
                </div>
                
                <div className="text-4xl md:text-5xl font-light text-gray-900 mb-2">
                  {stat.number}
                </div>
                
                <div className="text-lg font-medium text-gray-800 mb-2">
                  {stat.label}
                </div>
                
                <div className="text-sm text-gray-600 font-light">
                  {stat.description}
                </div>
              </div>
            </div>
          ))}
        </div>

        {/* Bottom section with progress bars */}
        <div className="mt-20 bg-[#FFF8E9] rounded-3xl p-12">
          <div className="grid grid-cols-1 md:grid-cols-2 gap-8">
            {progressItems.map((item, index) => (
              <div key={index} className="space-y-3">
                <div className="flex justify-between items-center">
                  <span className="font-medium text-gray-900">{item.label}</span>
                  <span className="text-2xl font-light text-[#22C55E]">{item.value}{item.suffix.includes('%') ? '%' : ''}</span>
                </div>
                <div className="w-full bg-white rounded-full h-2">
                  <div 
                    className="bg-[#22C55E] h-2 rounded-full transition-all duration-1000 ease-out"
                    style={{ width: `${item.value > 99 ? 100 : item.value}%` }}
                  ></div>
                </div>
                <span className="text-sm text-gray-600 font-light">{item.suffix}</span>
              </div>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
};
